module.exports = __webpack_public_path__ + "img/star.0a61cc26.svg";